import { render } from "./App.vue?vue&type=template&id=5dd470e7&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5dd470e7&lang=css"

import exportComponent from "E:\\Work\\WinNet\\SVN\\workplace\\WinnetHISv2022\\1.Develop\\OfficialAccount\\wnt.gzh.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__